enum DimensionSizing {
  // FIXED = 'fix',
  // RELATIVE = 'rel',
  FIXED = 'F',
  RELATIVE = 'R',
}

enum DimensionUnit {
  FIXED = 'px',
  RELATIVE = '%',
}

export { DimensionSizing, DimensionUnit };
